import mapboxgl from 'mapbox-gl';

// Normalize various LngLatLike shapes to a [lng, lat] tuple
export function toLngLatTuple(value: unknown): [number, number] | undefined {
    if (Array.isArray(value) && value.length >= 2) {
        const arr = value as unknown[];
        const lng = typeof arr[0] === 'number' ? arr[0] : undefined;
        const lat = typeof arr[1] === 'number' ? arr[1] : undefined;
        if (lng !== undefined && lat !== undefined) {
            return [lng, lat];
        }
    }
    if (value instanceof mapboxgl.LngLat) {
        return [value.lng, value.lat];
    }
    if (value && typeof value === 'object') {
        const v = value as { lat?: unknown; lng?: unknown; lon?: unknown };
        const lng = typeof v.lng === 'number' ? v.lng : typeof v.lon === 'number' ? v.lon : undefined;
        const lat = typeof v.lat === 'number' ? v.lat : undefined;
        if (lng !== undefined && lat !== undefined) {
            return [lng, lat];
        }
    }
    return undefined;
}
